import { Component, inject, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { ModalStateService } from "src/app/services/modal-service/modal-state.service";

@Component({
	selector: "app-employee-pin",
	templateUrl: "./employee-pin.page.html",
	styleUrls: ["./employee-pin.page.scss"],
	imports: [TranslateModule, FormsModule],
})
export class EmployeePINPage {
	pin: string;
	readonly showNfcOption = input(false);
	readonly errorMessage = input("");
	modalState: ModalStateService;
	constructor() {
		this.modalState = inject(ModalStateService);
	}

	onPinChange(v: string) {
		this.pin = v;
	}

	async closeModal(reason: string) {
		this.modalState.triggerDismiss("confirm", reason);
	}
}
